import { Image, TooltipDesktop, UIHeading6, UIText2 } from '@cian/ui-kit';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './SuperAgentLevelView.css';
import starSvg from './icons/star.svg';

type TSuperAgentLevelViewProps = {
  isSuperAgent: boolean;
  tooltip: string[];
};

export const SuperAgentLevelView: React.FC<TSuperAgentLevelViewProps> = ({ tooltip, isSuperAgent }) => {
  const key = React.useId();
  const labelText = isSuperAgent ? 'Суперагент' : 'Суперхозяин';

  return (
    <TooltipDesktop
      theme="white"
      title={
        <ul className={styles['tooltip']}>
          {tooltip.map((item, i) => (
            <li key={`${key}${i}`} className={styles['item']}>
              <IconFunctionalSuccess16 color="icon-positive-default" />
              <UIText2>{item}</UIText2>
            </li>
          ))}
        </ul>
      }
      placement="bottom"
    >
      <div className={styles['wrapper']}>
        <Image src={starSvg} height={16} width={16} />
        <UIHeading6 color="text-positive-default">{labelText}</UIHeading6>
      </div>
    </TooltipDesktop>
  );
};
